import format from 'date-fns/format';
import { proxyWeixinImageFn } from './tools.js';

const hasDot = (num) => {
  return num.toString().indexOf('.') !== -1;
};

export default {
  // 时间格式化
  'formatDate': (value, _format) => {
    if (!value) {
      return '';
    }
    const date = typeof value === 'number' ? value * 1000 : value;
    return format(date, _format ? _format : 'yyyy-MM-dd HH:mm:ss');
  },
  // 小数点位数
  'fixedNum': (num, fixLen = 1) => {
    return hasDot(num) ? num.toFixed(fixLen) : num;
  },
  // 四舍五入
  'mathRound': (num) => {
    return Math.round(num) || 0;
  },
  'cutHttp': (value, _format) => {
    if (!value) {
      return '';
    }
    return value.replace(/^http:/, '');
  },
  'proxyWeixinImage': (value) => {
    return proxyWeixinImageFn(value);
  },
  'formatPercent': (num, fix, place) => {
    const fixLen = fix ? fix : 2;
    const placeStr = place ? place : 'N/A';
    const num100 = num * 100;
    return Object.is(num, NaN) ? placeStr : `${hasDot(num100) ? num100.toFixed(fixLen) : num100}%`;
  }
};